import { RestaurantService } from './restaurant.service';
import { environment } from 'src/environments/environment';
import { Injectable, Injector } from '@angular/core';
import { Events } from './events.service';
import { ModalController, ToastController } from 'src/app/core/overlay';
import { TranslatePipe } from '@ngx-translate/core';
import { FormatTimePipe } from 'src/app/shared/pipe/formatTime.pipe';
import { DatePipe } from '@angular/common';
import { decodificarEntidadesHtml } from 'src/app/shared/utils/decodificar-entidades';
@Injectable({
	providedIn: 'root'
})
export class UtilsService {

	constructor(
		private injector: Injector,
		private events: Events,
		private toastController: ToastController,
		private translatePipe: TranslatePipe,
		private modalController: ModalController,
		private restaurantService: RestaurantService,
		private formatTime: FormatTimePipe,
		private datePipe: DatePipe

	) {
		if(!this.events) return;

		this.windowsResizesEvent();
	}

	windowsResizesEvent() {
		this.events.subscribe('windowResized', () => {

			let activeInputElement = document.activeElement;
			if (activeInputElement && activeInputElement.tagName.match(/INPUT|/g)) {
				let enterKeyHint = activeInputElement.getAttribute('enterkeyhint')
				if (enterKeyHint) {
					let keyboardShouldDismissOnKeyEnter = enterKeyHint.match(/done|search/g);

					if (keyboardShouldDismissOnKeyEnter) {
						// Handler NOMEADO para poder ser removido: a arrow anônima
						// de antes nunca era removível e era re-adicionada a cada
						// foco (leak), e o removeEventListener sem o 2º argumento
						// lançava `2 arguments required` (405×/dia na telemetria).
						const onKeydown = (event: any) => {
							if (event.keyCode == 13) this.hideKeyboard(activeInputElement, onKeydown);
						};
						activeInputElement.addEventListener('keydown', onKeydown, false);
					}
				}

				this.handleFooterSize(activeInputElement);
			}
		})

	}

	handleFooterSize(activeInputElement) {
		let shouldHideFooter = false;
		let currentFooter;
		let currentContent;

		document.querySelectorAll<HTMLElement>('.mp-content')
		.forEach((content) => {
			if (content.offsetHeight > 0 && content.offsetHeight < 320) {
				currentContent = content;
				shouldHideFooter = true;
			}
		});

		document.querySelectorAll<HTMLElement>('.mp-footer')
		.forEach((footer) => {

			var elems = footer.querySelectorAll(".hiddenFooterElement");
			let aarray:any = Array.from(elems).map((element) => element)

			for (let i = 0; i < aarray.length; i++) { 
				let element = aarray[i]								
				
				element.classList.remove('hiddenFooterElement');
			}			

			if (footer.offsetHeight > 0 && footer.childElementCount > 0 && shouldHideFooter) {
				try {
					activeInputElement.scrollIntoView({
						behavior: 'auto',
						block: 'center',
						inline: 'center'
					});
				} catch (e) {
					console.error(e);
				}

				this.recursiveSearchForButton(footer.children);		
			}
		});
	}

	recursiveSearchForButton(elementChildren) {
		let selectedChild;

		let childrenArray:any = Array.from(elementChildren).map((element) => element);

		for (let i = 0; i < childrenArray.length; i++) {
			let child:any = childrenArray[i];
			if(child.classList.contains('footerButton')){
				selectedChild = childrenArray.splice(i,1)[0];
				break;
			} 
		}		

		if (selectedChild) {
			if(selectedChild.childElementCount > 0)
				this.recursiveSearchForButton(selectedChild.children)

			for (let i = 0; i < childrenArray.length; i++) { 
				let element = childrenArray[i]				
				element.classList.add('hiddenFooterElement');

			}
		}

		return;
	}

	validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase()) && email != "";
	}

	validateCPF(strCPF) {
		if (strCPF) {
			const regex = /\b(\d)\1+\b/;
			let repeatedNumbers = regex.test(strCPF);
			if(repeatedNumbers) return false;
			
			const properLenght = 11;
			if (strCPF.length != properLenght) return false;

			var Soma;
			var Resto;
			Soma = 0;

			for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
			Resto = (Soma * 10) % 11;

			if ((Resto == 10) || (Resto == 11)) Resto = 0;
			if (Resto != parseInt(strCPF.substring(9, 10))) return false;

			Soma = 0;
			for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
			Resto = (Soma * 10) % 11;

			if ((Resto == 10) || (Resto == 11)) Resto = 0;
			if (Resto != parseInt(strCPF.substring(10, 11))) return false;
			return true;
		} else {
			return false
		}
	}

	private charToNumericValue(char: string): number {
		const charCode = char.toUpperCase().charCodeAt(0);
		const isDigit = charCode >= 48 && charCode <= 57;
		const isLetter = charCode >= 65 && charCode <= 90;

		return (isDigit || isLetter) ? charCode - 48 : 0;
	}

	validateCNPJ(cnpj: string): boolean {
		if (!cnpj) return false;

		const formatCharsRegex = /[.\-\/]/g;
		const twoDigitsRegex = /^\d{2}$/;
		const alphanumeric12Regex = /^[A-Z0-9]{12}$/;
		const allSameCharsRegex = /^(.)\1+$/;

		const sanitized = cnpj.replace(formatCharsRegex, '').toUpperCase();
		if (sanitized.length !== 14) return false;

		const baseChars = sanitized.substring(0, 12);
		const checkDigits = sanitized.substring(12);

		if (!twoDigitsRegex.test(checkDigits)) return false;
		if (!alphanumeric12Regex.test(baseChars)) return false;
		if (allSameCharsRegex.test(sanitized)) return false;

		const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
		let sum = 0;
		for (let i = 0; i < 12; i++) {
			sum += this.charToNumericValue(baseChars[i]) * weights1[i];
		}
		const firstDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);

		if (firstDigit !== parseInt(checkDigits[0])) return false;

		const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
		sum = 0;
		for (let i = 0; i < 12; i++) {
			sum += this.charToNumericValue(baseChars[i]) * weights2[i];
		}
		sum += firstDigit * weights2[12];
		const secondDigit = sum % 11 < 2 ? 0 : 11 - (sum % 11);

		if (secondDigit !== parseInt(checkDigits[1])) return false;

		return true;
	}

	validateCPFCNPJ(value: string): boolean {
		if (!value) return false;

		const formatCharsRegex = /[.\-\/]/g;
		const cpfRegex = /^\d{11}$/;

		const sanitized = value.replace(formatCharsRegex, '');

		if (cpfRegex.test(sanitized)) {
			return this.validateCPF(sanitized);
		}

		return this.validateCNPJ(value);
	}

	parseOrderPrevision(baseDate, minutesToAdd) {
		var t = baseDate.split(/[- :]/);
		var date = new Date( (new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5])) );

		date.setMinutes(date.getMinutes()+minutesToAdd);
		return this.formatTime.transform(date.getHours() + ':' + ("0"+date.getMinutes()).substr(-2));
	}

	timeConvert(minutes){
		if (minutes < 60) return `${minutes}min`;

		let hours = (minutes / 60);
		let parsedHours = Math.floor(hours);
		let min = (hours - parsedHours) * 60;
		let parsedMinutes = Math.round(min);

		return `${parsedHours}h ${parsedMinutes}min`;
	}

	hideKeyboard(activeInputElement, keydownHandler?) {
		activeInputElement.setAttribute('readonly', 'readonly');
		activeInputElement.setAttribute('disabled', 'true');
		setTimeout(function() {
			activeInputElement.blur();
			activeInputElement.removeAttribute('readonly');
			activeInputElement.removeAttribute('disabled');
			// removeEventListener EXIGE (tipo, listener); passar só o tipo lança.
			if (keydownHandler) activeInputElement.removeEventListener('keydown', keydownHandler);
		}, 100);
    }
    
    async createToaster(message = 'teste', durationInMilliseconds = 2000, color = 'dark') {
		const toast = await this.toastController.create({
			message: this.translatePipe.transform(message),
			position: 'top',
			color,
			duration: durationInMilliseconds
		});
		toast.present();        
    }

	copyToClipboard(text) {
		var textArea = document.createElement("textarea");
		textArea.value = text;

		textArea.style.top = "0";
		textArea.style.left = "0";
		textArea.style.position = "fixed";

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();
		document.execCommand('copy');
		document.body.removeChild(textArea);

		this.createToaster('Copiado com sucesso!');
	}

	immediatelyOrderPrevision(order) {
		let minutes = this.restaurantService.restaurant.info.delivery_time_max;

		if (order.deliveryType == 'balcony')
			minutes = this.restaurantService.restaurant.info.takeout_time;

		return this.parseOrderPrevision(order.createdAt, minutes);
	};

	scheduleOrderPrevision(dateTime, minutesToAdd) {
        var dateMin = new Date(dateTime.replace(/-/g, "/"));    
        var dateMax = new Date(dateTime.replace(/-/g, "/"));
    
        dateMax.setMinutes(dateMax.getMinutes()+minutesToAdd);

		return this.datePipe.transform(dateMin,this.translatePipe.transform('dateFormatWithoutYearWithHour')) + " - " +  
			this.datePipe.transform(dateMax,this.translatePipe.transform('dateFormatWithoutYearWithHour'));
    }

	findStreetNumber(searchInput: string): string | null {
		// Try to find a number at the end of the string
		const regex = /(\d+)$/;
		const match = regex.exec(searchInput);
		if (match) {
			return match[1];
		}

		// If no number is found at the end, search for the rightmost number
		const lastNumber = searchInput.match(/\d+/g)?.slice(-1)[0];
		if (lastNumber) {
			return lastNumber;
		}

		// If no number is found, return null
		return null;
	}

	normalizeText(value: string): string {
		if (!value) {
		  return '';
		}

		return value.normalize('NFKC');
	  }

	removeTags(str: string) {
		try {
			let result = decodificarEntidadesHtml(str)?.replace(/<\/?[^>]+(>|$)/g, "");
			result = this.normalizeText(result)
			return result.replace(/^"(.*)"$/, '$1').replace(/\\(.)/g, '$1');
		} catch (error) {
			return str;
		}
	}

	sanitizeAndFormatText(value: any): string {
		if (!value || typeof value !== 'string') {
			return '';
		}

		return value
			.replace(/\u00A0/g, ' ')
			.replace(/\u200B/g, ' ')
			.replace(/\u200C/g, ' ')
			.replace(/\u200D/g, ' ')
			.replace(/&nbsp;/g, ' ')
			.replace(/&ZeroWidthSpace;/g, ' ')
			.replace(/-/g, '&#8203;-')
			.replace(/([a-zA-Z]{20,})/g, '$1&#8203;');
	}
}